import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

const ClassTrainerDetails = (props) => {
  const [data, setData] = useState([]);
  const [loading, setLoader] = useState(false);

  const value = useSelector((state) => state.viewDetails);
  const [index, setIndex] = useState(value.index);

  useEffect(() => {
    const result = props.data.map((item) => {
      return {
        ...item,
        Nestingdate: item.NestingDate
          ? moment(new Date(item.NestingDate)).format("YYYY-MM-DD")
          : "",
        Productiondate: item.ProductionDate
          ? moment(new Date(item.ProductionDate)).format("YYYY-MM-DD")
          : "",
        NestingEnddate: item.NestingEndDate
          ? moment(new Date(item.NestingEndDate)).format("YYYY-MM-DD")
          : "",
      };
    });

    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <div>
          <Grid className="p-10px" container spacing={2}>
            <Grid item xs={4} container>
              <Grid item xs={5}>
                Wave :
              </Grid>
              <Grid item xs={7}>
                {data[index].Wave}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Production Status :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].ProductionStatus}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Reschedule/Transfer Details :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].RescheduleTransferDetails}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Rescheduled Moved to New Roster :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].RescheduledMovedToNewRoster}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Training Space :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].TrainingSpace}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Attended Nesting:
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].AttendedNesting != null
                  ? data[index].AttendedNesting === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Nesting Status:
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].NestingStatus}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Nesting Date/Time :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].Nestingdate} {data[index].NestingTime}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Nesting End Date / Time :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].NestingEnddate} {data[index].NestingEndTime}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Attended Production :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].AttendedProduction != null
                  ? data[index].AttendedProduction === true
                    ? "Yes"
                    : "No"
                  : null}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Production Date :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].Productiondate}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Trainee Status:
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].TraineeStatus}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Trainer Name :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].TrainerName}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Trainer Email :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].TrainerEmail}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                OG Name :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].OGName}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                OG Email :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].OGEmail}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                OG Team Email :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].OGTeamEmail}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Operational Team <br /> Lead :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].OperationalTeamLead}
              </Grid>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Operational Team Lead Email :
              </Grid>
              <Grid item xs={7} sx={{ marginTop: 10 }}>
                {data[index].OperationalTeamLeadEmail}
              </Grid>
            </Grid>
            <Grid item xs={4} container>
              <Grid item xs={5} sx={{ marginTop: 10 }}>
                Pre - Training Comments :
              </Grid>
              <Grid
                item
                xs={7}
                sx={{ marginTop: 10, height: 40, overflow: "scroll" }}
              >
                {data[index].PretrainingComment}
              </Grid>
            </Grid>
            <Grid item xs={4}></Grid>
          </Grid>
        </div>
      ) : null}
    </>
  );
};

export default ClassTrainerDetails;
